import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { TemplateVersion } from "types/generated";

const TemplatesTableDescriptionCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<TemplateVersion>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={template.instructions} />
    </TableSimpleCell>
  );
};

export default TemplatesTableDescriptionCell;
